// S3 Bucket Configuration
// Replace this URL with your actual S3 bucket public URL
// 
// To configure:
// 1. Set REACT_APP_S3_BASE_URL in your .env file (see .env.example)
// 2. Or update the default value below
//
// Format examples:
// - https://sdti-s3-bucket.s3.amazonaws.com/images
// - https://sdti-s3-bucket.s3.ap-south-1.amazonaws.com/images
// - https://your-cloudfront-domain.cloudfront.net/images
//
// Note: Do NOT include trailing slash after 'images'

const S3_BASE_URL = process.env.REACT_APP_S3_BASE_URL || 'https://sdti-s3-bucket.s3.amazonaws.com/images';

/**
 * Converts a local image path to S3 URL
 * @param {string} imagePath - Local image path (e.g., "/images/logo.png", "./images/logo.png", "../images/logo.png")
 * @returns {string} Full S3 URL
 */
export const getImageUrl = (imagePath) => {
  if (!imagePath) return '';
  
  // If already a full URL (http/https), return as is
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }
  
  // Remove leading slashes, dots, and normalize path
  let normalizedPath = imagePath
    .replace(/^\.\//, '') // Remove ./
    .replace(/^\.\.\//, '') // Remove ../
    .replace(/^\//, ''); // Remove leading /
  
  // Remove 'images/' prefix if present (since S3_BASE_URL already includes it)
  normalizedPath = normalizedPath.replace(/^images\//, '');
  
  // Construct full S3 URL
  const s3Url = `${S3_BASE_URL}/${normalizedPath}`;
  
  return s3Url;
};

export default S3_BASE_URL;
